import { Badge } from "@fluentui/react-components";

import type { AggregateStatus } from "@/types/domain";

const COLOR: Record<AggregateStatus, "warning" | "success" | "danger" | "informative" | "subtle"> = {
  pending_review: "warning",
  approved: "success",
  // Email contains only archive-only docs — never went through review.
  // Distinct from "approved" (which means an operator approved a reviewable
  // doc), so operators don't conflate them.
  archive_only: "informative",
  // "archived" at the email level rolls archived+removed together; both are
  // deliberate operator decisions, not failures, so render neutral grey.
  archived: "informative",
  failed: "danger",
  mixed: "informative",
};

const LABEL: Record<AggregateStatus, string> = {
  pending_review: "Pending review",
  approved: "Approved",
  archive_only: "Archive only",
  archived: "Discarded",
  failed: "Failed",
  mixed: "Mixed",
};

export function StatusBadge({ status }: { status: AggregateStatus }) {
  return (
    <Badge appearance="filled" color={COLOR[status]}>
      {LABEL[status]}
    </Badge>
  );
}
